<template>
  <b-col>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="generalcontainerplanes">
      <hr>

      <div class="row">
        <div class="col-12">
          <label>Leyenda de Ahorros:</label>
          <div>
            <p>{{ leyenda }}</p>
          </div>
        </div>

      </div>
      <h5>Imágenes</h5>
       <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <b-form-group
              label="Detalle de la Cobertura :"
              label-for="identificadorconvenio"
              description="Debe escoger una imagen .png, maximo de dimensiones 700 x 750px y un peso máximo de 54KB.">
            <b-form-file
                id="identificadorconvenio"
                accept="image/*"
                @change="uploadImage($event,3)"
                browse-text="Abrir"
                placeholder="Seleccinar imagen"
                ref="inputFile">
            </b-form-file>
          </b-form-group>
          </div>
          <br>
          <div v-if="imagenpresupuestos != null">
            <img alt="img"  :src="imagenpresupuestos">
          </div>
       </div>

    </div>

  </b-col>
</template>

<script>
import {required, numeric} from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "caracteristicas",
  props: ['idPlan', 'plan'],
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      numAuto: {
        vigencia: null,
        longitud: null,
        formato: null
      },
      numPoli: {
        vigencia: null,
        longitud: null,
        formato: null
      },
      leyenda: 'Gracias a tu Plan Dental,  tus ahorros acumulados a la fecha son de $$',
      imagen: null,
      identificador: null,
      imagenrecibos: null,
      imagenpresupuestos: null,
    }
  },
  validations: {
    numAuto: {
      vigencia: {required, numeric},
      longitud: {required, numeric},
      formato: {required}
    },
    numPoli: {
      vigencia: {required, numeric},
      longitud: {required, numeric},
      formato: {required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerCaracteristicas()
    this.leyenda = 'Gracias a tu Plan Dental ' + this.plan + ',  tus ahorros acumulados a la fecha son de $$';
    this.guardarLeyenda();
  },
  methods: {
    obtenerCaracteristicas() {
      const parametros = {idPlan: this.idPlan}
      this.$http.post(this.$api + 'planConvenio/obtenerCaracteristicas', parametros).then(respuesta => {
        if (respuesta.data.data) {
          this.numAuto = respuesta.data.data.autorizacion;
          this.numPoli = respuesta.data.data.poliza;

          this.identificador = this.convertirImagen(respuesta.data.data.identificador);
          this.imagenrecibos = this.convertirImagen(respuesta.data.data.imagenrecibos);
          this.imagenpresupuestos = this.convertirImagen(respuesta.data.data.imagenpresupuestos);
        }

      })
    },
    convertirImagen(datos) {

      if (datos === null){
        return null;
      }

      let binary = '';
      let bytes = new Uint8Array(datos);
      let len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return 'data:image/jpeg;base64,' + btoa(binary);
    },
    guardarNumAuto() {
      this.$v.numAuto.$touch();
      if (this.$v.numAuto.$anyError) {
        return;
      }
      if (!this.$v.numAuto.$invalid) {
        this.$http.post(this.$api + 'planConvenio/guardar/NumeroAutorizacion?idPlan=' + this.idPlan, this.numAuto).then(respuesta => {
          if (respuesta.data.data) {
            this.info();
          }

        })
      }
    },
    guardarNumPoli() {
      this.$v.numPoli.$touch();
      if (this.$v.numPoli.$anyError) {
        return;
      }
      if (!this.$v.numPoli.$invalid) {
        this.$http.post(this.$api + 'planConvenio/guardar/NumeroPoliza?idPlan=' + this.idPlan, this.numPoli).then(respuesta => {
          if (respuesta.data.data) {
            this.info();
          }

        })
      }
    },
    guardarLeyenda() {
      this.$http.post(this.$api + 'planConvenio/guardar/leyenda', {
        idPlan: this.idPlan,
        leyenda: this.leyenda
      }).then(() => {

      })
    },
    validateStateNumAuto(name) {
      const {$dirty, $error} = this.$v.numAuto[name];
      return $dirty ? !$error : null;
    },
    validateStateNumPoli(name) {
      const {$dirty, $error} = this.$v.numPoli[name];
      return $dirty ? !$error : null;
    },
    atras(uno, dos) {
      this.$emit('set-Done', uno, dos)
    },
    adelante(uno, dos) {
      this.$emit('set-Done', uno, dos)
    },
    uploadImage(event, imagen) {
      const name = event.target.files[0].name;
      const lastDot = name.lastIndexOf('.');

      let files = event.target.files || event.dataTransfer.files;
      const file = new Blob([files[0]], {type: "image/png"});

      //Validacion de peso de la imagen, debe ser menor a 54 Kibibyte (Convertido a Bytes)
      if (file.size > 55296) {
        this.$swal({
          icon: "error",
          title: "No se puede guardar, la imagen es muy pesada.",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
        this.$refs.inputFile.reset();
        return false;
      }

      let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let img = new Image();
          img.src = evt.target.result;
             img.onload = () => {
          if (img.width > 700 || img.height > 750) {
          this.$swal({
                icon: "error",
                title: "La imagen excede del tamaño 700px x 750px",
                confirmButtonText: "OK",
                confirmButtonColor: "#0e6ba9",
          });
          this.$refs.inputFile.reset();
          return false;
          }else{
            
      const fileName = name.substring(0, lastDot);
      const ext = name.substring(lastDot + 1);

      let config = {
        header: {
          "Content-Type": "image/png",
        },
      };

      const formData = new FormData();
      formData.append("imagenBase", file, fileName);
      formData.append("idPlan", this.idPlan);
      formData.append("nombre", fileName);
      formData.append("ext", ext);
      formData.append("tipo", imagen);

      this.$http.post(this.$api + 'planConvenio/guardar/imagen', formData, config).then(respuesta => {
        if (respuesta.data.data) {
          var reader = new FileReader()
          reader.readAsDataURL(event.target.files[0])
          reader.onload = () => {
            switch (imagen) {
              case 1:
                this.identificador = reader.result;
                break;
              case 2:
                this.imagenrecibos = reader.result;
                break;
              case 3:
                this.imagenpresupuestos = reader.result;
                break;
            }
          };
          this.$swal({
              icon: "success",
              text: "Se registró correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9"
           });
        }

      })
          }
            }
        };
    }
  },
  notifications: {
    info: {
      type: VueNotifications.types.info,
      title: "Exíto",
      message: "Guardado con éxito",
    }
  },
}
</script>

<style scoped>

</style>
